import { Modal } from "antd";
import { Template } from "../../api/models";
import Create from "./create";
import Upload from "./upload";
import Rename from "./rename";
import Delete from "./delete";
import Details from "./details";

export enum TemplateFunction {
  None = "None",
  Create = "Create",
  Upload = "Upload",
  Rename = "Rename",
  Delete = "Delete",
  Details = "Details"
}

interface TemplateParams {
  templateFunction: TemplateFunction,
  template?: Template,
  onClose: () => void
  onSave: (template: Template) => void,
  onDelete: (template: Template) => void,
  onDeleteRequested: () => void,
  onDeleteClose: () => void,
  onRenameRequested: () => void,
  onRenameClose: () => void,
  onCreateWorkOrder: () => void,
  onConfirmed: (template: Template) => void,
  onCreate: (template: Template) => void
};

export default function (p: TemplateParams) {
  const isOpen = p.templateFunction !== TemplateFunction.None;
  return (
    <Modal
      open={isOpen}
      closable={false}
      onCancel={p.onClose}
    >
      {
        p.templateFunction === TemplateFunction.Create ?
          <Create
            onClose={p.onClose}
            onCreate={p.onCreate}
          /> : undefined
      }
      {
        p.templateFunction === TemplateFunction.Upload ?
          <Upload
            template={p.template}
            onClose={p.onClose}
            onReady={p.onConfirmed}
          /> : undefined
      }
      {
        p.templateFunction === TemplateFunction.Delete ?
          <Delete
            template={p.template}
            onClose={p.onDeleteClose}
            onDelete={p.onDelete}
          /> : undefined
      }
      {
        p.templateFunction === TemplateFunction.Rename ?
          <Rename
            template={p.template}
            onClose={p.onRenameClose}
            onSave={p.onSave}
          /> : undefined
      }
      {
        p.templateFunction === TemplateFunction.Details ?
          <Details
            template={p.template}
            onClose={p.onClose}
            onCreateWorkOrder={p.onCreateWorkOrder}
            onDeleteRequested={p.onDeleteRequested}
            onRenameRequested={p.onRenameRequested}
          /> : undefined
      }
    </Modal>
  );
}